/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */
import { Playground, Props } from 'docz'
import Field from './'
import TextInput from '../textInput'
import Checkbox from '../checkbox'
import Textarea from '../textarea'
import { Direction } from "../../common/direction";
import { Intent } from "../../common/intent";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "field"
    }}>{`Field`}</h1>
    <p>{`A `}<inlineCode parentName="p">{`Field`}</inlineCode>{` wraps a single form field (`}<inlineCode parentName="p">{`<input>, <select>, <textarea>`}</inlineCode>{`),
a `}<inlineCode parentName="p">{`name`}</inlineCode>{` prop, and optional `}<inlineCode parentName="p">{`hint`}</inlineCode>{` and `}<inlineCode parentName="p">{`alert`}</inlineCode>{` props into a `}<inlineCode parentName="p">{`<label>`}</inlineCode>{` element
and arranges them according to the `}<inlineCode parentName="p">{`direction`}</inlineCode>{` and `}<inlineCode parentName="p">{`reverse`}</inlineCode>{` props.`}</p>
    <p>{`Direction is vertical by default. Passing `}<inlineCode parentName="p">{`direction={Direction.HORIZONTAL}`}</inlineCode>{`
and `}<inlineCode parentName="p">{`reverse`}</inlineCode>{` will position the `}<inlineCode parentName="p">{`label`}</inlineCode>{` to the right of the `}<inlineCode parentName="p">{`input`}</inlineCode>{`, which is
the preferred layout for a checkbox or radio button.`}</p>
    <p>{`For a group of radio buttons, use `}<a parentName="p" {...{
        "href": "/components/toggleField"
      }}>{`ToggleField`}</a>{` instead.`}</p>
    <h2 {...{
      "id": "vertical"
    }}>{`Vertical`}</h2>
    <Playground __position={0} __code={'<Field name=\"Name of your third grade teacher\" mb={6}>\n  <TextInput placeholder=\"Mrs. Kennedy\" />\n</Field>\n<Field\n  name=\"Name of your fourth grade teacher\"\n  desc=\"If you don\'t remember, make something up\"\n  alert=\"Please fill out this field\"\n  required\n  mb={6}\n>\n  <TextInput placeholder=\"Mrs. Eager\" required />\n</Field>\n\n<Field name=\"Describe your fifth grade experience\">\n  <Textarea placeholder=\"Happy and fun!\" />\n</Field>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Field,
      TextInput,
      Checkbox,
      Textarea,
      Direction,
      Intent
    }} mdxType="Playground">
    <Field name="Name of your third grade teacher" mb={6} mdxType="Field">
        <TextInput placeholder="Mrs. Kennedy" mdxType="TextInput" />
    </Field>
      <Field name="Name of your fourth grade teacher" desc="If you don't remember, make something up" alert="Please fill out this field" required mb={6} mdxType="Field">
    <TextInput placeholder="Mrs. Eager" required mdxType="TextInput" />
      </Field>

      <Field name="Describe your fifth grade experience" mdxType="Field">
    <Textarea placeholder="Happy and fun!" mdxType="Textarea" />
      </Field>
    </Playground>
    <h2 {...{
      "id": "horizontal"
    }}>{`Horizontal`}</h2>
    <Playground __position={1} __code={'<Field\n  name=\"Name of school\"\n  alert=\"Hey I went there too\"\n  alertIntent={Intent.SUCCESS}\n  direction={Direction.HORIZONTAL}\n  nameWidth=\"24rem\"\n  required\n  mb={6}\n>\n  <TextInput defaultValue=\"Arkham Elementary\" />\n</Field>\n<Field\n  name=\"Name of your second grade teacher\"\n  direction={Direction.HORIZONTAL}\n  nameWidth=\"24rem\"\n  mb={6}\n>\n  <TextInput placeholder=\"Mrs. Hall\" />\n</Field>\n\n<Field\n  name=\"Name of your first grade teacher\"\n  desc=\"Don\'t remember? Ask your fourth grade teacher.\"\n  alert=\"Please fill out this field\"\n  direction={Direction.HORIZONTAL}\n  nameWidth=\"24rem\"\n  required\n  mb={6}\n>\n  <TextInput placeholder=\"Mrs. Hall\" required />\n</Field>\n\n<Field\n  name=\"Describe your sixth grade experience\"\n  direction={Direction.HORIZONTAL}\n  nameWidth=\"24rem\"\n>\n  <Textarea placeholder=\"Groovy\" />\n</Field>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Field,
      TextInput,
      Checkbox,
      Textarea,
      Direction,
      Intent
    }} mdxType="Playground">
    <Field name="Name of school" alert="Hey I went there too" alertIntent={Intent.SUCCESS} direction={Direction.HORIZONTAL} nameWidth="24rem" required mb={6} mdxType="Field">
        <TextInput defaultValue="Arkham Elementary" mdxType="TextInput" />
    </Field>
      <Field name="Name of your second grade teacher" direction={Direction.HORIZONTAL} nameWidth="24rem" mb={6} mdxType="Field">
    <TextInput placeholder="Mrs. Hall" mdxType="TextInput" />
      </Field>

      <Field name="Name of your first grade teacher" desc="Don't remember? Ask your fourth grade teacher." alert="Please fill out this field" direction={Direction.HORIZONTAL} nameWidth="24rem" required mb={6} mdxType="Field">
    <TextInput placeholder="Mrs. Hall" required mdxType="TextInput" />
      </Field>

      <Field name="Describe your sixth grade experience" direction={Direction.HORIZONTAL} nameWidth="24rem" mdxType="Field">
    <Textarea placeholder="Groovy" mdxType="Textarea" />
      </Field>
    </Playground>
    <h2 {...{
      "id": "horizontal-reverse"
    }}>{`Horizontal reverse`}</h2>
    <Playground __position={2} __code={'<Field\n  name=\"Label after the input\"\n  direction={Direction.HORIZONTAL}\n  reverse\n  mb={4}\n>\n  <Checkbox />\n</Field>\n<Field\n  name=\"Use for checkboxes and radios\"\n  desc=\"Don\'t forget `reverse` and `direction={Direction.HORIZONTAL}`\"\n  direction={Direction.HORIZONTAL}\n  reverse\n>\n  <Checkbox />\n</Field>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Field,
      TextInput,
      Checkbox,
      Textarea,
      Direction,
      Intent
    }} mdxType="Playground">
    <Field name="Label after the input" direction={Direction.HORIZONTAL} reverse mb={4} mdxType="Field">
        <Checkbox mdxType="Checkbox" />
    </Field>
      <Field name="Use for checkboxes and radios" desc="Don't forget `reverse` and `direction={Direction.HORIZONTAL}`" direction={Direction.HORIZONTAL} reverse mdxType="Field">
    <Checkbox mdxType="Checkbox" />
      </Field>
    </Playground>
    <h3 {...{
      "id": "proptypes"
    }}>{`PropTypes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Prop`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Label props`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "/components/label"
            }}>{`Label`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`nameWidth`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`applies to direction `}<inlineCode parentName="td">{`HORIZONTAL`}</inlineCode>{` only`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`required`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bool`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`appends an asterisk to name`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`direction`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`enum`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`VERTICAL`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "/common/direction"
            }}>{`Direction`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`reverse`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bool`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`puts name after the input. applies to direction `}<inlineCode parentName="td">{`HORIZONTAL`}</inlineCode>{` only`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`desc`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`a description or hint`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`alert`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bold message, typically used to signal invalid input`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`alertIntent`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`enum`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`Intent.DANGER`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`determines alert message color`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`size`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`enum`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`Size.MEDIUM`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`must also pass this to children`}</td>
        </tr>
      </tbody>
    </table>
    </MDXLayout>;
}

MDXContent.isMDXComponent = true;
  